import { useMutation, useQueryClient } from '@tanstack/react-query'

import useAuth from 'hooks/useAuth'
import axiosServices from 'utils/axios'

const markDownloadAsSeen = async (businessId: number, ids: number[]) => {
  return axiosServices.post(`/businesses/${businessId}/user_downloads/mark_as_seen`, {
    ids
  })
}

export const useMarkDownloadAsSeen = () => {
  const { user } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ ids }: { ids: number[] }) => {
      if (!user?.business_id) throw new Error('Business ID is required')

      return markDownloadAsSeen(user?.business_id!, ids)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fetch-user-downloads', user?.business_id] })
    }
  })
}
